/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UrlSlug from './url-slug';
import UrlSlugDetail from './url-slug-detail';
import UrlSlugUpdate from './url-slug-update';
import UrlSlugDeleteDialog from './url-slug-delete-dialog';

const UrlSlugRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UrlSlug />} />
    <Route path="new" element={<UrlSlugUpdate />} />
    <Route path=":id">
      <Route index element={<UrlSlugDetail />} />
      <Route path="edit" element={<UrlSlugUpdate />} />
      <Route path="delete" element={<UrlSlugDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UrlSlugRoutes;
